import _functionUncurryThis from "../internals/function-uncurry-this";
import _toObject from "../internals/to-object";
var exports = {};
var uncurryThis = _functionUncurryThis;
var toObject = _toObject;
var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};
export default exports;